module.exports = __webpack_public_path__ + "media/products/pcb_noon-d6974dab.svg";